import React from 'react'
import './ConstructionChemicals.scss'
import SupplementaryServices from '../components/SupplementaryServices'

const ConstructionChemicals = () => {

    let mapData = {
        title: "Construction <span> Chemicals</span>",
        desc: "Hutaib Industrial Solutions offers a broad spectrum of top-tier chemicals, developed to meet the dynamic needs of multiple industries.",
        mapItem: [

            {
                title: 'Epoxy Resin',
                description: 'A high-strength bonding agent ideal for structural repairs, coatings, and chemical-resistant applications.',
                slug: 'epoxy-resin',
                localImage: '/assets/images/Epoxy.webp'
            }, {
                title: 'Admixture',
                description: 'A performance-enhancing additive that improves concrete workability, strength, and setting time.',
                slug: 'admixture',
                localImage: '/assets/images/admixture.webp'
            },
        ]
    }

    return (
        <div className='Wrapme'>
            <SupplementaryServices data={mapData} />
        </div>
    )
}

export default ConstructionChemicals